import { Reducer } from 'redux';
import { ILookupType, ILookupTypeState } from '../common/defaults';
import * as actionTypes from './types';
const $ = require('jquery');

// Type-safe initialState!
const initialState: ILookupTypeState = {
  allTypes: [],
  activeTypes: [],
  lookups: [],
  lookupTypes: [],
  selectedLookupType: null,
  typesByName: [],
};

const reducer: Reducer<ILookupTypeState> = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_TYPES: {
      let _state = { ...state };
      _state = { ..._state, allTypes: action.value };
      return _state;
    }
    case actionTypes.GET_ACTIVE_TYPES: {
      let _state = { ...state };
      _state = { ..._state, activeTypes: action.value };
      return _state;
    }
    case actionTypes.GET_LOOKUP_TYPES: {
      let _state = { ...state };
      _state = { ..._state, lookupTypes: action.value };
      return _state;
    }
    case actionTypes.GET_LOOKUPS_BY_TYPE: {
      let _state = { ...state };
      _state = { ..._state, lookups: action.value };
      return _state;
    }
    case actionTypes.GET_TYPE_BY_NAME: {
      let _state = { ...state };
      _state = { ..._state, typesByName: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
